import cn from 'clsx';
import { dayjs } from 'r/utils';
import type { EventResult } from 'r/atoms';

export const formatDate = (date: string | null | undefined) =>
  date ? dayjs(date).format('DD.MM.YYYY') : '—';

export const formatHitRate = (hitRate: number | null) =>
  hitRate === null ? '—' : `${Math.round(hitRate * 100)}%`;

export function NewKolBadge() {
  return (
    <span className="px-2 py-0.5 bg-blue-500/10 text-blue-500 border border-blue-500/20 text-[10px] font-semibold rounded-full uppercase tracking-wide">
      New
    </span>
  );
}

export function HitMissCounts({
  hits,
  misses,
  neutrals,
}: {
  hits: number;
  misses: number;
  neutrals: number;
}) {
  return (
    <span className="inline-flex items-center gap-2 text-xs font-medium">
      <span className="text-green-500" title="Hit">
        {hits}
      </span>
      <span className="text-red-500" title="Miss">
        {misses}
      </span>
      <span className="text-secondary" title="Neutral (range outcome)">
        {neutrals}
      </span>
    </span>
  );
}

const resultConfig: Record<EventResult, { label: string; className: string }> =
  {
    hit: {
      label: 'Hit',
      className: 'bg-green-500/10 text-green-500 border-green-500/20',
    },
    miss: {
      label: 'Miss',
      className: 'bg-red-500/10 text-red-500 border-red-500/20',
    },
    neutral: {
      label: 'Neutral',
      className: 'bg-gray-500/10 text-gray-500 border-gray-500/20',
    },
    pending: {
      label: 'Pending',
      className: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
    },
  };

export function EventResultBadge({ result }: { result: EventResult }) {
  return (
    <span
      className={cn(
        'px-2 py-0.5 text-[10px] font-medium rounded-full border whitespace-nowrap',
        resultConfig[result].className,
      )}
    >
      {resultConfig[result].label}
    </span>
  );
}

export function DirectionBadge({ isUp }: { isUp: boolean }) {
  return (
    <span
      className={cn(
        'px-2 py-0.5 text-[10px] font-bold rounded-md uppercase border',
        isUp ?
          'bg-green-500/10 text-green-500 border-green-500/20'
        : 'bg-red-500/10 text-red-500 border-red-500/20',
      )}
    >
      {isUp ? 'Up' : 'Down'}
    </span>
  );
}
